import http from '@/services'
import { encodeQueryValues } from '@/utils/utils'
class TrayService {
  constructor() {
    this._baseURL =
      (localStorage.getItem('API_URL') ||
        process.env.VUE_APP_BASEURL ||
        'http://localhost:8000/api/') + 'tray-temp/'
    this._categoryURL = 'categories'
    this._manufacturerURL = 'manufacturers'
    this._productURL = 'product'
    this.orderURL = 'order'
  }

  hasParameter(string) {
    if (string.substr(string.length - 1) === '?') return false
    return true
  }

  createRequestUrl(url, payload) {
    let requestUrl = `${url}?`

    if (payload && payload.categoriaPai)
      requestUrl += this.hasParameter(requestUrl)
        ? `&PARENT_ID=${payload.categoriaPai}`
        : `PARENT_ID=${payload.categoriaPai}`
    if (payload && payload.id)
      requestUrl += this.hasParameter(requestUrl)
        ? `&id=${payload.id}`
        : `id=${payload.id}`
    if (payload && payload.todos)
      requestUrl += this.hasParameter(requestUrl)
        ? `&TODOS=${payload.todos}`
        : `TODOS=${payload.todos}`
    if (payload && payload.integrados)
      requestUrl += this.hasParameter(requestUrl)
        ? `&INTEGRADOS=${payload.integrados}`
        : `INTEGRADOS=${payload.integrados}`
    if (payload && payload.categoryName)
      requestUrl += this.hasParameter(requestUrl)
        ? `&CATEGORIAINTNOME=${payload.categoryName}`
        : `CATEGORIAINTNOME=${payload.categoryName}`
    if (payload && payload.manufacturerName)
      requestUrl += this.hasParameter(requestUrl)
        ? `&FABRICANTE=${payload.manufacturerName}`
        : `FABRICANTE=${payload.manufacturerName}`

    if (payload && typeof payload.operatorQuantity == 'number') {
      requestUrl += this.hasParameter(requestUrl)
        ? `&OPERATORQTY=${payload.operatorQuantity}`
        : `OPERATORQTY=${payload.operatorQuantity}`
    }
    if (payload && typeof payload.operatorWeight == 'number') {
      requestUrl += this.hasParameter(requestUrl)
        ? `&OPERATORWGT=${payload.operatorWeight}`
        : `OPERATORWGT=${payload.operatorWeight}`
    }

    if (payload && payload.quantity)
      requestUrl += this.hasParameter(requestUrl)
        ? `&QUANTIDADE=${payload.quantity}`
        : `QUANTIDADE=${payload.quantity}`

    if (payload && payload.weight)
      requestUrl += this.hasParameter(requestUrl)
        ? `&PESO=${payload.weight}`
        : `PESO=${payload.weight}`

    if (payload && payload.columns)
      requestUrl += this.hasParameter(requestUrl)
        ? `&COLUNASSQL=${payload.columns.toString()}`
        : `COLUNASSQL=${payload.columns.toString()}`

    if (payload && payload.export)
      requestUrl += this.hasParameter(requestUrl)
        ? `&EXPORT=${payload.export}`
        : `EXPORT=${payload.export}`

    if (payload && payload.vendaInternet)
      requestUrl += this.hasParameter(requestUrl)
        ? `&VENDAINTERNET=${payload.vendaInternet ? 'S' : 'N'}`
        : `VENDAINTERNET=${payload.vendaInternet ? 'S' : 'N'}`

    if (payload && payload.dataini)
      requestUrl += this.hasParameter(requestUrl)
        ? `&DATAINI=${payload.dataini}`
        : `DATAINI=${payload.dataini}`

    if (payload && payload.datafim)
      requestUrl += this.hasParameter(requestUrl)
        ? `&DATAFIM=${payload.datafim}`
        : `DATAFIM=${payload.datafim}`

    if (payload && payload.numero)
      requestUrl += this.hasParameter(requestUrl)
        ? `&NUMERO=${payload.numero}`
        : `NUMERO=${payload.numero}`

    return requestUrl
  }

  async getOrders(payload = {}) {
    let requestUrl = this.createRequestUrl(
      `${this._baseURL}${this.orderURL}`,
      payload
    )
    const { data } = await http.get(requestUrl)
    return data
  }

  //Categories
  async getCategoriesIntegration(payload = {}) {
    let requestUrl = this.createRequestUrl(
      `${this._baseURL}${this._categoryURL}/index-gestao`,
      payload
    )
    const { data } = await http.get(requestUrl)
    return data
  }

  async getCategoryIntegration(payload) {
    let requestUrl = `${this._baseURL}${this._categoryURL}/gestao/${payload}`
    const { data } = await http.get(requestUrl)
    return this.translateCategoryFromFirebird(data)
  }

  async updateCategory(payload, id) {
    let requestUrl = `${this._baseURL}${this._categoryURL}/${id}`
    const data = this.translateCategoryToFirebird(payload)
    return await http.post(requestUrl, data)
  }

  async integrateCategories(payload) {
    let requestUrl = `${this._baseURL}${this._categoryURL}/integrate`
    return await http.post(requestUrl, payload)
  }

  translateCategoryToFirebird(value) {
    let obj = {
      ID: value.codigo,
      NOME: value.nome,
      SUBTITULO: value.subtitulo,
      PARENT_ID: value.categoriaPai ? value.categoriaPai.ID : null,
      IDINTEGRACAO: value.idIntegracao,
      PARENT_IDINTEGRACAO: value.parentIdIntegracao,
    }
    return obj
  }

  translateCategoryFromFirebird(value) {
    let obj = {
      codigo: value.ID,
      nome: value.NOME,
      subtitulo: value.SUBTITULO,
      categoriaPai: value.PARENT_ID ? { ID: value.PARENT_ID } : undefined,
      idIntegracao: value.IDINTEGRACAO,
      parentIdIntegracao: value.PARENT_IDINTEGRACAO,
    }
    return obj
  }

  // Fabricantes
  async getManufacturerIntegration(id) {
    let requestUrl = `${this._baseURL}${this._manufacturerURL}/gestao/${id}`
    const { data } = await http.get(requestUrl)
    return this.translateManufacturerFromFirebird(data)
  }

  async getManufacturersIntegration(payload = {}) {
    let requestUrl = this.createRequestUrl(
      `${this._baseURL}${this._manufacturerURL}/index-gestao`,
      payload
    )
    const { data } = await http.get(requestUrl)
    return data
  }

  async integrateManufacturers(payload) {
    let requestUrl = `${this._baseURL}${this._manufacturerURL}/integrate`
    return await http.post(requestUrl, payload)
  }

  translateManufacturerToFirebird(value) {
    let obj = {
      FABRICANTE: value.nome,
      IDINTEGRACAO: value.idIntegracao,
    }
    return obj
  }

  translateManufacturerFromFirebird(value) {
    let obj = {
      nome: value.FABRICANTE,
      idIntegracao: value.IDINTEGRACAO,
    }
    return obj
  }

  //Produtos
  async getProductsIntegration(payload = {}) {
    payload = encodeQueryValues(payload)
    let requestUrl = this.createRequestUrl(
      `${this._baseURL}${this._productURL}/index-gestao`,
      payload
    )
    const { data } = await http.get(requestUrl)
    return data
  }

  translateProductToFirebird(value) {
    let obj = {
      CODIGO: value.codigo,
      DIASPARAMANIPULACAO: value.prazoDisponibilidade,
      IDITEMINTEGRACAO: value.idItemIntegracao,
      VENDAINTERNET: value.vendaInternet ? 'S' : 'N',
      ISPERMITIRCOMPRA: value.isProdutoSobConsulta ? 'S' : 'N',
      ISPRODUTODESTAQUE: value.isSeloDestaque ? 'S' : 'N',
      ISPRODUTOEXCLUSIVO: value.isSeloAdicional ? 'S' : 'N',
      ISPRODUTOLANCAMENTO: value.isSeloLancamento ? 'S' : 'N',
      PRECO:
        parseFloat(value.preco) == parseFloat(value.precoVarejo)
          ? null
          : value.preco,
      PRECOVAREJO: value.precoVarejo,
      QUANTIDADECRITICA: value.estoqueMinimo,
      categorias: value.categorias,
      categories:
        value.categorias && value.categorias.length > 0
          ? value.categorias.map((element) => ({
              ID: element.ID,
            }))
          : null,
      FABRICANTE_INTEGRACAO: value.fabricanteIntegracao,
      CONVERTEPESOGRAMAS: value.convertePesoGramas,
    }
    return obj
  }

  translateProductFromFirebird(value, priceIntegrationField = 'PRECOVAREJO') {
    let obj = {
      codigo: value.CODIGO,
      descricao: value.DESCRICAO ?? value.item.DESCRICAO,
      prazoDisponibilidade: value.DIASPARAMANIPULACAO,
      idItemIntegracao: value.IDITEMINTEGRACAO,
      isProdutoSobConsulta: value.ISPERMITIRCOMPRA == 'S',
      isSeloDestaque: value.ISPRODUTODESTAQUE == 'S',
      isSeloAdicional: value.ISPRODUTOEXCLUSIVO == 'S',
      isSeloLancamento: value.ISPRODUTOLANCAMENTO == 'S',
      vendaInternet: value.VENDAINTERNET == 'S',
      preco: value.PRECO ?? value.item[priceIntegrationField] ?? null,
      precoVarejo: value.item ? value.item[priceIntegrationField] : value.PRECO,
      estoqueMinimo: value.QUANTIDADECRITICA,
      categorias: value.categorias ?? [],
      fabricanteIntegracao: value.FABRICANTE_INTEGRACAO,
    }
    return obj
  }

  async getProductIntegration(id) {
    let requestUrl = `${this._baseURL}${this._productURL}/${id}`
    const { data } = await http.get(requestUrl)
    return this.translateProductFromFirebird(data)
  }

  async getProductColumnsAvaiable() {
    const requestUrl = `${this._baseURL}${this._productURL}/columns-avaiable`
    const { data } = await http.get(requestUrl)
    return data
  }

  async updateProduct(payload, id) {
    let requestUrl = `${this._baseURL}${this._productURL}/${id}`
    return await http.post(requestUrl, payload)
  }

  async integrateProducts(payload) {
    let requestUrl = `${this._baseURL}${this._productURL}/integrate`
    return await http.post(requestUrl, payload)
  }

  // Pedidos
  async integrateOrders(payload) {
    let requestUrl = `${this._baseURL}order`
    return await http.post(requestUrl, payload)
  }

  // webhooks simulator
  async removeProduct(payload) {
    let requestUrl = `${this._baseURL}${this._productURL}/notification-removed`
    return await http.post(requestUrl, payload)
  }
  async removeCategory(payload) {
    let requestUrl = `${this._baseURL}${this._categoryURL}/notification-removed`
    return await http.post(requestUrl, payload)
  }
  async removeManufacturer(payload) {
    let requestUrl = `${this._baseURL}${this._manufacturerURL}/notification-removed`
    return await http.post(requestUrl, payload)
  }
}

export default new TrayService()
